export default {
  neutral: {
    0: '#ffffff',
    10: '#fafbfb',
    20: '#f5f6f7',
    30: '#ebedf0',
    40: '#dfe2e6',
    50: '#c2c7d0',
    60: '#b3b9c4',
    70: '#a6aebb',
    80: '#98a1b0',
    90: '#8993a4',
    100: '#7a8699',
    200: '#6b788e',
    300: '#5d6b82',
    400: '#505f79',
    500: '#42526d',
    600: '#354764',
    700: '#243757',
    800: '#15294b',
    900: '#091e42',
  },
  red: {
    50: '#ffebea',
    100: '#ffc2bf',
    200: '#ffa5a0',
    300: '#ff7c74',
    400: '#ff6259',
    500: '#ff3b30',
    600: '#D32F2F',
    700: '#B71C1C',
    800: '#8c201a',
    900: '#6b1914',
  },
  orange: {
    50: '#fff4e6',
    100: '#ffdeb0',
    200: '#ffce8a',
    300: '#ffb854',
    400: '#ffaa33',
    500: '#ff9500',
    600: '#e88800',
    700: '#b56a00',
    800: '#8c5200',
    900: '#6b3f00',
  },
  yellow: {
    50: '#fffae6',
    100: '#ffefb0',
    200: '#ffe88a',
    300: '#ffdd54',
    400: '#ffd633',
    500: '#ffcc00',
    600: '#e8ba00',
    700: '#b59100',
    800: '#8c7000',
    900: '#6b5600',
  },
  green: {
    50: '#ebf9ee',
    100: '#c0eecc',
    200: '#a2e5b3',
    300: '#77d990',
    400: '#5dd27a',
    500: '#34c759',
    600: '#2fb551',
    700: '#258d3f',
    800: '#1d6d31',
    900: '#165425',
  },
  blue: {
    50: '#e6f2ff',
    100: '#b0d6ff',
    200: '#8ac2ff',
    300: '#54a6ff',
    400: '#3395ff',
    500: '#007aff',
    600: '#006fe8',
    700: '#0057b5',
    800: '#00446C',
    900: '#002F4B',
  },
  indigo: {
    50: '#eeeefb',
    100: '#cbcbf2',
    200: '#b2b1ec',
    300: '#8f8ee4',
    400: '#7978de',
    500: '#5856d6',
    600: '#504ec3',
    700: '#3e3d98',
    800: '#302f76',
    900: '#25245a',
  },
  gray: {
    50: '#fafbfb',
    100: '#f5f6f7',
    200: '#ebedf0',
    300: '#dfe2e6',
    400: '#c2c7d0',
    500: '#b3b9c4',
    600: '#a6aebb',
    700: '#98a1b0',
    800: '#8993a4',
    900: '#7a8699',
  },
} as const
